export const CustomerDelivery = () => {
  return <div>delivery</div>;
};
